import info from '../../subassembly/info'
import progressM from '../../subassembly/progress'
import survey from '../../subassembly/survey'
import transportOverview from '../../subassembly/transportOverview'
import frontconrtM from '../../subassembly/frontconrt'
import backconrtM from '../../subassembly/backconrt'
import alarm from '../../subassembly/alarm'
import {
    mapState
} from 'vuex'
export default {
    components:{
        info,
        progressM,
        survey,
        transportOverview,
        frontconrtM,
        backconrtM,
        alarm
    },
    data() {
        return {
            engineerVal:'',
            sectionVal:'',
            onlyOneImg:1
        }
    },
    created() {
        
     },
    mounted() { 
    // this.login()
    },
    methods: {
        // async login() {
        //     let hashUrl = window.location.hash.split('?')[1].split('&')
        //     let val = []
        //     hashUrl.forEach((item,i)=> {
        //         val.push(item.split('=')[1])
                
        //     })
        //     console.log(val)
        //     this.engineerVal =val[0]
        //     this.sectionVal =val[1]
        //     this.$store.commit('updataEngineerId',this.engineerVal)
        //     this.$store.commit('updataSectionId',this.sectionVal)
        //     console.log(this.engineerId)
        //     console.log(this.sectionId)
        //     let req={
        //         username: 'admin',
        //         password: 'jsjk2020'
        //     }
        //     const data = await this.$http.post("/sso/login?username=admin&password=jsjk2020")
        //     if (data.data.code != 200) return this.$message({ message:data.data.msg , type: 'error' })
        //   this.$message({
        //     type: "success",
        //     message:"Approval successfully"
        //   });
        //   },
        changeImg(val) {
            this.onlyOneImg = val
            console.log(this.onlyOneImg)
        }
    },
    computed: mapState([
        'engineerId','sectionId'
    ])
}


// WEBPACK FOOTER //
// ./src/components/lqLayer/lqLayer-mixins.js